// removed by extract-text-webpack-plugin
module.exports = {"contentContainer":"index__contentContainer___3vduG","buttonsContainer":"index__buttonsContainer___2DDuj","container":"index__container___3h7rw","cancel":"index__cancel___2Bu2s","accept":"index__accept___2Wjhc","scopeList":"index__scopeList___2jatd","checkBox":"index__checkBox___3z4bR","title":"index__title___2IBpy","email":"index__email___gUCXC"};


//////////////////
// WEBPACK FOOTER
// ./src/consent/components/Consent/index.css
// module id = 896
// module chunks = 0